export const socialAnimation = {
  in: {
    opacity: 1,
    x: 0,
  },
  out: {
    opacity: 0,
    x: -100,
  },
};
export const socialTransition = {
  delay: 2,
  duration: 1,
};

export const greetAnimation = {
  in: {
    opacity: 1,
    scale: 1,
  },
  out: {
    opacity: 0,
    scale: 0.5,
  },
};
export const greetTransition = {
  delay: 2.5,
  duration: 1,
};

export const nameAnimation = {
  in: {
    opacity: 1,
    scale: 1,
  },
  out: {
    opacity: 0,
    scale: 0.5,
  },
};
export const nameTransition = {
  delay: 2.9,
  duration: 1,
};

export const occAnimation = {
  in: {
    opacity: 1,
    scale: 1,
  },
  out: {
    opacity: 0,
    scale: 0.5,
  },
};
export const occTransition = {
  delay: 3.4,
  duration: 1,
};

export const buttonAnimation = {
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: 100,
  },
};
export const buttonTransition = {
  delay: 3.9,
  duration: 1,
};
